import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import { Chip } from '@material-ui/core';
const CurrentRefinements = ({ items, refine, createURL }) => {
  const RefinementChip = (props)=>(
      <Chip
          label={props.item.currentRefinement?props.item.currentRefinement:props.item.label}
          onDelete={event => {
            event.preventDefault();
            refine(props.item.value);
          }}
          variant="outlined"
          size="small"
          style={{margin:4}}
      />
    );
    
  return (
  <div>
   {items.map(item => (
    !item.items?
      <RefinementChip item={item} key={item.label}/>
      :item.items.map(nested =>(
        <RefinementChip item={nested} key={item.label}/>
      ))
    
      ))
   }
  </div>
  )
  
};



const ConnectedCurrentRefinements = connectCurrentRefinements(CurrentRefinements);
export default ConnectedCurrentRefinements;


// WEBPACK FOOTER //
// ./src/components/Algolia/ConnectedCurrentRefinements.js